"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumScheduleMode = void 0;
/**
 * 预定会议状态
 */
var EnumScheduleMode;
(function (EnumScheduleMode) {
    /**
     * 预定状态
     */
    EnumScheduleMode[EnumScheduleMode["Schedule"] = 0] = "Schedule";
    /**
     * 编辑全部会议
     * 普通会议：修改本次会议
     * 周期性会议：修改全部周期性会议
     */
    EnumScheduleMode[EnumScheduleMode["EditAllMeeting"] = 1] = "EditAllMeeting";
    /**
     * 编辑周期性会议的单次会议
     */
    EnumScheduleMode[EnumScheduleMode["EditSingleMeeting"] = 2] = "EditSingleMeeting";
})(EnumScheduleMode = exports.EnumScheduleMode || (exports.EnumScheduleMode = {}));
//# sourceMappingURL=schedule.js.map